import React, { useEffect, useState } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Flex,
  Box,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import isEmpty from 'lodash/isEmpty';
import { ModalType } from 'constants/common';
import { DomainAccessValidate } from 'utils/validation';
import { toast } from 'components/Toast';
import InputController from 'components/Form/InputController';
import { useAddDomainAccess, useUpdateDomainAccess } from 'services/system';

const AddSourceAccessModal = ({ ipDetail, isOpen, onClose, refetch }) => {
  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(DomainAccessValidate),
    defaultValues: {
      domain: '',
    },
  });

  const addDomainAccessMutation = useAddDomainAccess();
  const updateDomainAccessMutation = useUpdateDomainAccess();

  useEffect(() => {
    if (!isEmpty(ipDetail)) {
      reset({
        name: ipDetail?.name,
        domain: ipDetail?.domain,
      });
    }
  }, [ipDetail]);

  const onSubmit = values => {
    const dataSubmit = {
      ...values,
    };

    if (ipDetail) {
      updateDomainAccessMutation.mutate(
        {
          ...dataSubmit,
          id: ipDetail?._id,
        },
        {
          onSuccess: () => {
            toast.showMessageSuccess('Chỉnh sửa link thành công');
            onClose(ModalType.Add);
            refetch();
          },
        }
      );
      return;
    }

    addDomainAccessMutation.mutate(
      {
        ...dataSubmit,
      },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Thêm link thành công');
          onClose(ModalType.Add);
          refetch();
        },
      }
    );
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      onClose={() => {
        onClose(ModalType.Add);
      }}
      isOpen={isOpen}
      isCentered
      size="2xl"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        {/* <AlertDialogHeader textTransform="uppercase">{`Tạo trò chơi`}</AlertDialogHeader> */}
        <AlertDialogCloseButton />
        <AlertDialogBody>
          <form>
            <InputController
              styleContainer={{
                marginBottom: '1rem',
              }}
              control={control}
              name="name"
              isRequired
              label="Tên"
            />
            <InputController
              styleContainer={{
                marginBottom: '1rem',
              }}
              control={control}
              name="domain"
              isRequired
              label="Link"
            />
          </form>
        </AlertDialogBody>
        <AlertDialogFooter justifyContent="center">
          <Flex gap="14px">
            <Button
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Đóng
            </Button>
            <Button
              colorScheme="blue"
              isLoading={addDomainAccessMutation.isPending || updateDomainAccessMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              Lưu
            </Button>
          </Flex>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AddSourceAccessModal;
